import { css } from '@emotion/react';

import type { severities } from '@core/notifications/LocalNotification/getLocalNotificationCss';
import { severityColor } from '@core/notifications/LocalNotification/getLocalNotificationCss';

export default (severity?: keyof typeof severities) => css`
  margin: 0 0 var(--cds-spacing-50);
  ${severity && `color: ${severityColor[severity]}`};
`;
